import { trackReviewDetails } from "./trackReviewDetails";
import { trackUberPayment } from "./trackUberPayment";
import { trackViewPayment } from "./trackViewPayment";

export const checkoutServices = {
  trackReviewDetails,
  trackViewPayment,
  trackUberPayment,
};
